/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import {
  afectacionesEnum,
  dataTypesEnum,
  // tiposDeContribuyentesSolicitantesEnum,
} from 'views/Tramites/GPM/enums';
// import { toMoment } from 'utils/normalizers';
import { store } from 'store/index';
import { percentajeValidator } from 'utils/rules';
import calculateValorBase, { tiposDocumentosExentos } from 'views/Catastro/utils/calculateValorBase';
import { hasPermission } from 'utils/permission';
import { getTasasDeTrasladoDePredios } from 'api/catastro';
import { toMoment } from 'utils/normalizers';

const getFieldsInfoClaves = () => {
  const tiposDeClavesDePredios = store.getState().catalogs.tiposDeClavesDePredios || [];
  const llavesDePredios = store.getState().catalogs.llavesDePredios || [];
  const entries = llavesDePredios.map((config) => {
    const tiposDeClave = tiposDeClavesDePredios.find((c) => c.id === config.clave_de_predio);
    return [
      tiposDeClave?.clave,
      {
        id: tiposDeClave?.clave,
        nombre_en_la_bd: tiposDeClave?.clave,
        tipo_de_dato_del_campo: config.es_alfanumerica ? dataTypesEnum.CHAR : dataTypesEnum.INTEGER,
        null: !config.es_requerido,
      },
    ];
  });
  const obj = Object.fromEntries(entries);
  return obj;
};

const getFieldsConfigClaves = () => {
  const tiposDeClavesDePredios = store.getState().catalogs.tiposDeClavesDePredios || [];
  const llavesDePredios = store.getState().catalogs.llavesDePredios || [];

  const entries = llavesDePredios.map((conf) => {
    const tiposDeClave = tiposDeClavesDePredios.find((c) => c.id === conf.clave_de_predio);
    const _config = {
      formItemProps: {
        label: tiposDeClave?.descripcion,
        rules: [
          { required: conf.es_requerido },
          {
            validator: async (_, value) => {
              if (value) {
                const _message = 'El campo debe contener {MSG} caracteres';
                if (conf.longitud_minima === conf.longitud_maxima
                  && value.length !== conf.longitud_minima) {
                  throw new Error(_message.replace('{MSG}', conf.longitud_minima));
                }
                if (value.length < conf.longitud_minima) {
                  throw new Error(_message.replace('{MSG}', `mínimo ${conf.longitud_minima}`));
                }
                if (value.length > conf.longitud_maxima) {
                  throw new Error(_message.replace('{MSG}', `máximo ${conf.longitud_maxima}`));
                }
              }
            },
          },
        ],
      },
    };

    return [tiposDeClave?.clave, _config];
  });
  const obj = Object.fromEntries(entries);
  return obj;
};

const fieldsInfo = {
  ...getFieldsInfoClaves(),
  es_propietario_ciudadano: {
    id: 'es_propietario_ciudadano',
    nombre_en_la_bd: 'es_propietario_ciudadano',
    tipo_de_dato_del_campo: dataTypesEnum.BOOLEAN,
  },
  valor_catastral_calculado: {
    id: 'valor_catastral_calculado',
    nombre_en_la_bd: 'valor_catastral_calculado',
    tipo_de_dato_del_campo: dataTypesEnum.FOREIGN_KEY,
    model: 'tramite.Tramite',
  },
};

const getTabs = () => [
  {
    title: 'General',
    fields: [
      ...Object.keys(getFieldsInfoClaves()),
      'tipo_de_predio',
      'tipo_de_predio_urbano',
      'regimen_de_propiedad',
      'uso_de_predio',
      'es_ejidal',
      'etapa',
      'clave_inegi',
      'subpredio',
      'recaudadora',
      'zona',
    ],
    key: 'general',
  },
  {
    title: 'Detalle',
    fields: [
      'tipo_de_valuacion',
      'fecha_visita',
      'perito_contribuyente',
      'responsable_cartografia',
      'notas_adicionales',
      'observaciones',
      'observaciones_subdivision',
      'tiene_cartografia',
      'avaluo_externo',
      'predio_con_accesorios',
      'tasa_baldio',
      'es_manifestacion_voluntaria',
    ],
    key: 'detalle',
  },
  {
    title: 'Valores y medidas',
    fields: [
      'superficie_total_del_terreno',
      'valor_del_terreno',
      'area_titulo',
      'superficie_de_la_construccion',
      'valor_de_la_construccion',
      'valor_catastral',
      'tasa',
      'frente',
      'indiviso',
      'profundidad',
      'perimetro',
      'factor_merito_demerito',
      'porcentaje_demerito',
      'motivo_demerito',
    ],
    key: 'valoresMedidas',
  },
  {
    title: 'Servicios',
    fields: [
      'tiene_servicio_de_agua',
      'tiene_alumbrado',
      'tiene_banqueta',
      'tiene_drenaje',
      'tiene_electricidad',
      'tiene_telefono',
      'pavimento',
    ],
    key: 'servicios',
  },
  {
    title: 'Transmisión Patrimonial',
    fields: [
      'tipo_de_avaluo',
      // 'avaluo_comercial_traslado',
      'tipo_de_documento_traslado',
      'aplica_avaluo',
      'aplica_beneficio_ley',
      'valor_catastral_calculado',
      'escritura',
      'lugar_notaria',
      // 'precio_pactado_traslado',
      'valor_catastral',
      'area_titulo',
      'fecha_traslado',
      'fecha_adjudicacion_traslado',
      'fecha_de_celebracion',
      'valor_operacion_traslado',
      'tasa_marginal',
      'numero_de_inscripcion_registro_publico',
      'anio_referido_traslado',
      'bimestre_referido_traslado',
      'observaciones_traslado',
      'esta_exento',
      // 'aplica_tasa_referencial',
      'omitir_valores_referenciados',
      'valor_base_traslado',
      'factor_traslado',
      'tipo_de_valuacion',
      'tipo_de_cuenta',
      'porcentaje_traslado',
      'remplaza_regimenes',
      'notario_contribuyente',
      'notario_manual',
      'uso_de_predio',
    ],
    key: 'traslado',
  },
];

const forbiddenProps = [
  'direccion',
  'direccion_notificacion',
  'ciudadano',
  'contribuyente',
];

const onChange = (all) => {
  const { formInstance, dataSources, padron } = all;
  const values = formInstance.getFieldsValue();
  const newValues = calculateValorBase(padron, values, dataSources.Tramite);
  formInstance.setFieldsValue(newValues);
};

const setTasaMarginal = async ({ formInstance }) => {
  await new Promise((resolve) => setTimeout(() => resolve(true)));
  const { fecha_traslado, valor_catastral_calculado, valor_catastral } = formInstance.getFieldsValue();
  const tasas = await getTasasDeTrasladoDePredios({ periodo: toMoment(fecha_traslado)?.format('YYYY') });
  const valorCat = typeof valor_catastral_calculado === 'string'
    ? parseFloat(valor_catastral_calculado.split('_')[1])
    : valor_catastral;
  const tasa = tasas.find((t) => valorCat <= t.limite_superior && valorCat >= t.limite_inferior);
  formInstance.setFieldValue('tasa_marginal', tasa?.tasa_marginal);
};

const getConfigs = () => ({
  // TAB: General
  valor_catastral_calculado: {
    formItemProps: {
      label: 'Avalúo',
      rules: [(formInstance) => ({ required: formInstance.getFieldValue('aplica_avaluo') })],
    },
    ignoreBaseRequired: true,
    updateOnChange: ['aplica_avaluo'],
    controlProps: {
      onChange: (...args) => {
        onChange(...args);
        setTasaMarginal(...args);
      },
    },
  },
  tipo_de_predio: {
    formItemProps: {
      label: 'Tipo De Predio',
      required: true,
    },
  },
  tipo_de_predio_urbano: {
    formItemProps: {
      label: 'Tipo De Predio Urbano',
      required: true,
    },
  },
  regimen_de_propiedad: {
    formItemProps: {
      label: 'Tipo de propiedad',
    },
  },
  uso_de_predio: {
    formItemProps: {
      label: 'Uso de suelo',
      required: true,
    },
    controlProps: { onChange },
  },
  es_ejidal: {
    formItemProps: {
      label: '¿Es ejidal?',
    },
  },
  etapa: {
    formItemProps: {
      label: 'Etapa',
    },
  },
  clave_inegi: {
    formItemProps: {
      label: 'Clave INEGI',
    },
  },
  subpredio: {
    formItemProps: {
      label: 'Subpredio',
    },
    controlProps: { disabled: true },
  },
  recaudadora: {
    formItemProps: {
      label: 'Recaudadora',
      required: true,
    },
    controlProps: { labelProp: 'clave' },
    colProps: { md: 16 },
    defaultValue: ({ user }) => user.unidad_de_recaudacion,
  },
  zona: {
    formItemProps: {
      label: 'Zona',
    },
  },

  // TAB: Detalle
  tipo_de_avaluo: {
    formItemProps: {
      label: 'Tipo de avaluo',
    },
    controlProps: { onChange },
  },
  tipo_de_valuacion: {
    formItemProps: {
      label: 'Tipo de valuación',
    },
  },
  fecha_visita: {
    formItemProps: {
      label: 'Fecha visita',
    },
  },
  perito_contribuyente: {
    formItemProps: {
      label: 'Perito',
    },
    controlProps: {
      keyLabelRender: true,
      labelProp: 'nombre_completo',
      // disabled: ({ plantillaDeTramite }) => plantillaDeTramite.tipo_de_contribuyente_solicitante
      //   ?.id === tiposDeContribuyentesSolicitantesEnum.PERITO,
    },
    overrideValue: ({ padronSolicitante }) => {
      if (padronSolicitante.es_perito) return padronSolicitante.id;
      return undefined;
    },
  },
  responsable_cartografia: {
    formItemProps: {
      label: 'Responsable cartografía',
    },
  },
  numero_de_avaluo: {
    formItemProps: {
      label: 'Número de avaluo',
    },
  },
  notas_adicionales: {
    formItemProps: {
      label: 'Notas',
    },
    controlProps: { autoSize: { minRows: 3 } },
    colProps: { md: 24 },
  },
  observaciones_subdivision: {
    formItemProps: {
      label: 'Observaciones subdivisión',
    },
    controlProps: { autoSize: { minRows: 3 } },
    colProps: { md: 24 },
  },
  observaciones: {
    formItemProps: {
      label: 'Observaciones',
    },
    controlProps: { autoSize: { minRows: 3 } },
    colProps: { md: 24 },
  },
  tiene_cartografia: {
    formItemProps: {
      label: '¿Tiene cartografía?',
    },
  },
  avaluo_externo: {
    formItemProps: {
      label: 'Avalúo externo',
    },
  },
  predio_con_accesorios: {
    formItemProps: {
      label: 'Predio con accesorios',
    },
  },
  tasa_baldio: {
    formItemProps: {
      label: 'Tasa baldio',
    },
  },
  es_manifestacion_voluntaria: {
    formItemProps: {
      label: '¿Es manifestación voluntaria?',
    },
  },

  // TAB: valores y medidas
  superficie_total_del_terreno: {
    formItemProps: {
      label: 'Superficie de terreno',
    },
    controlProps: {
      disabled: true,
      precision: 3,
      commas: true,
    },
  },
  valor_del_terreno: {
    formItemProps: {
      label: 'Valor Terreno',
    },
    controlProps: {
      disabled: true,
      precision: 3,
      commas: true,
    },
  },
  // area_titulo
  superficie_de_la_construccion: {
    formItemProps: {
      label: 'Superficie Construcción',
    },
    controlProps: {
      disabled: true,
      precision: 3,
      commas: true,
    },
  },
  valor_de_la_construccion: {
    formItemProps: {
      label: 'Valor Construcción',
    },
    controlProps: {
      disabled: true,
      precision: 3,
      commas: true,
    },
  },
  valor_catastral: {
    formItemProps: {
      label: 'Valor fiscal',
    },
    controlProps: {
      disabled: true,
      precision: 3,
      commas: true,
    },
  },
  tasa: {
    formItemProps: {
      label: 'Tasa',
    },
    controlProps: {
      disabled: true,
      precision: 6,
    },
  },
  frente: {
    formItemProps: {
      label: 'Frente',
    },
    controlProps: {
      precision: 2,
      commas: true,
    },
  },
  indiviso: {
    formItemProps: {
      label: 'Indiviso',
    },
    controlProps: {
      precision: 8,
      commas: true,
    },
  },
  profundidad: {
    formItemProps: {
      label: 'Profundidad',
    },
    controlProps: {
      precision: 2,
      commas: true,
    },
  },
  perimetro: {
    formItemProps: {
      label: 'Perímetro',
    },
    controlProps: {
      precision: 2,
      commas: true,
    },
  },
  factor_merito_demerito: {
    formItemProps: {
      label: 'Demérito',
    },
    controlProps: {
      precision: 2,
      commas: true,
    },
  },
  porcentaje_demerito: {
    formItemProps: {
      label: 'Porcentaje Demérito',
    },
    controlProps: {
      precision: 4,
      commas: true,
    },
  },
  motivo_demerito: {
    formItemProps: {
      label: 'Motivo Demérito',
    },
  },

  // TAB:  servicios
  tiene_servicio_de_agua: {
    formItemProps: {
      label: 'Agua',
    },
  },
  tiene_alumbrado: {
    formItemProps: {
      label: 'Alumbrado',
    },
  },
  tiene_banqueta: {
    formItemProps: {
      label: 'Banqueta',
    },
  },
  tiene_drenaje: {
    formItemProps: {
      label: 'Drenaje',
    },
  },
  tiene_electricidad: {
    formItemProps: {
      label: 'Electricidad',
    },
  },
  tiene_telefono: {
    formItemProps: {
      label: 'Teléfono',
    },
  },
  pavimento: {
    formItemProps: {
      label: 'Pavimento',
    },
  },

  // TAB:  traslado
  // avaluo_comercial_traslado: {
  //   formItemProps: {
  //     label: 'Número de Avalúo',
  //   },
  // },
  tipo_de_documento_traslado: {
    formItemProps: {
      label: 'Acto de Transmisión ',
    },
    controlProps: { onChange },
    overrideValue: null,
  },
  aplica_beneficio_ley: {
    formItemProps: {
      label: 'Aplica Ley Bis 117',
      tooltip: 'Aplica el artículo Bis de la Ley de Hacienda Municipal',
    },
    controlProps: {
      disabled: ({ formInstance }) => !tiposDocumentosExentos
        .includes(formInstance.getFieldValue('tipo_de_documento_traslado')),
    },
    updateOnChange: 'tipo_de_documento_traslado',
    overrideValue: false,
  },
  aplica_avaluo: {
    formItemProps: {
      label: 'Aplica Avalúo',
    },
    controlProps: {
      onChange: (...args) => {
        onChange(...args);
        setTasaMarginal(...args);
      },
    },
    defaultValue: true,
  },
  escritura: {
    formItemProps: {
      label: 'Número de escritura',
    },
    overrideValue: null,
  },
  lugar_notaria: {
    formItemProps: {
      label: 'Lugar de otorgamiento',
    },
    overrideValue: ({ padronSolicitante }) => {
      const municipio = padronSolicitante?.direcciones?.codigo_postal?.municipio?.nom_mun;
      if (municipio) return municipio;
      return undefined;
    },
  },
  // precio_pactado_traslado: {
  //   formItemProps: {
  //     label: 'Valor de la transmisión',
  //   },
  //   overrideValue: ({ recibo }) => recibo?.importe_total,
  // },
  area_titulo: {
    formItemProps: {
      label: 'Área título',
    },
    controlProps: {
      disabled: ({ plantillaDeTramite }) => {
        if (hasPermission('editar_area_titulo_predio_gpm')) return false;
        return plantillaDeTramite.tipo_de_afectacion !== afectacionesEnum.ALTA;
      },
      precision: 3,
      commas: true,
    },
  },
  fecha_traslado: {
    formItemProps: {
      label: 'Fecha de otorgamiento',
      required: true,
    },
    controlProps: {
      onChange: (...args) => {
        onChange(...args);
        setTasaMarginal(...args);
      },
    },
    overrideValue: null,
  },
  fecha_adjudicacion_traslado: {
    formItemProps: {
      label: 'Fecha de adjudicación',
    },
    overrideValue: null,
  },
  fecha_de_celebracion: {
    formItemProps: {
      label: 'Fecha de firmas',
    },
    overrideValue: null,
  },
  valor_operacion_traslado: {
    formItemProps: {
      label: 'Valor de la operación',
    },
    controlProps: { onChange },
    overrideValue: null,
  },
  tasa_marginal: {
    formItemProps: {
      label: 'Tasa marginal',
    },
    controlProps: {
      disabled: true,
    },
  },
  numero_de_inscripcion_registro_publico: {
    formItemProps: {
      label: 'Folio RPP',
    },
    colProps: { md: 8 },
    overrideValue: null,
  },
  anio_referido_traslado: {
    formItemProps: {
      label: 'Año referido',
    },
    controlProps: { onChange },
    overrideValue: null,
  },
  bimestre_referido_traslado: {
    formItemProps: {
      label: 'Bim referido',
    },
    controlProps: { onChange },
    overrideValue: null,
  },
  observaciones_traslado: {
    formItemProps: {
      label: 'Observaciones',
    },
    controlProps: { autoSize: { minRows: 3 } },
    colProps: { md: 24 },
  },
  esta_exento: {
    formItemProps: {
      label: 'Exento',
    },
    overrideValue: false,
  },
  // aplica_tasa_referencial: {
  //   formItemProps: {
  //     label: 'Aplica tasa referencial',
  //   },
  // },
  omitir_valores_referenciados: {
    formItemProps: {
      label: 'Omitir valores referenciados',
    },
    controlProps: { onChange },
    overrideValue: true,
  },
  valor_base_traslado: {
    formItemProps: {
      label: 'Valor base',
    },
    controlProps: {
      disabled: true,
      precision: 3,
      commas: true,
    },
  },
  factor_traslado: {
    formItemProps: {
      label: 'Factor',
    },
  },
  tipo_de_cuenta: {
    formItemProps: {
      label: 'Tipo de cuenta',
    },
  },
  porcentaje_traslado: {
    formItemProps: {
      label: 'Porcentaje total de la transmisión',
      rules: [percentajeValidator(), { required: true }],
    },
    controlProps: { onChange },
    overrideValue: null,
  },
  remplaza_regimenes: {
    formItemProps: {
      label: 'Remplaza regímenes',
    },
  },
  notario_contribuyente: {
    formItemProps: {
      label: 'Notario',
    },
    controlProps: {
      keyLabelRender: true,
      labelProp: 'nombre_completo',
      // disabled: ({ plantillaDeTramite }) => plantillaDeTramite.tipo_de_contribuyente_solicitante
      //   ?.id === tiposDeContribuyentesSolicitantesEnum.NOTARIO,
    },
    overrideValue: ({ padronSolicitante }) => {
      if (padronSolicitante?.es_notario) return padronSolicitante.id;
      return undefined;
    },
  },
  notario_manual: {
    formItemProps: {
      label: 'Notario Predio Manual',
    },
    showIf: (values) => values.notario_contribuyente === 0,
    updateOnChange: 'notario_contribuyente',
  },

  // NO USADOS ACTUALMENTE POR TLAJOMULCO
  folio_traslado: {
    formItemProps: {
      label: 'Folio de traslación',
    },
    hidden: true,
    overrideValue: ({ tramite }) => tramite?.folio,
  },
  fecha_de_escritura: {
    formItemProps: {
      label: 'Fecha de escritura pública',
    },
  },
  operacion_de_traslado: {
    formItemProps: {
      label: 'Operación',
    },
  },
  dependencia_reguladora_traslado: {
    formItemProps: {
      label: 'Dependencia reguladora',
    },
  },
  base_gravable: {
    formItemProps: {
      label: 'Base gravable',
    },
  },
  clave: {
    formItemProps: {
      label: 'Clave',
    },
    controlProps: {
      disabled: true,
      placeholder: 'Por Asignar',
    },
  },
  ...getFieldsConfigClaves(),
});

export default {
  configs: getConfigs,
  forbiddenProps,
  fieldsInfo,
  tabs: getTabs,
};
